var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoReceipts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 138,
    viewBox: "0 0 157 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Enable Push Notifications"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.822 75.4676C141.822 109.451 114.273 137 80.2897 137C46.3066 137 18.7578 109.451 18.7578 75.4676C18.7578 41.4846 46.3066 13.9352 80.2897 13.9352C114.273 13.9352 141.822 41.4846 141.822 75.4676Z",
    stroke: "#C4C3C3",
    strokeWidth: 0.827259,
    strokeDasharray: "4.15 4.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.984 75.4676C125.984 100.704 105.526 121.162 80.2897 121.162C55.053 121.162 34.5959 100.704 34.5959 75.4676C34.5959 50.2316 55.053 29.7733 80.2897 29.7733C105.526 29.7733 125.984 50.2316 125.984 75.4676Z",
    stroke: "#C4C3C3",
    strokeWidth: 0.827259,
    strokeDasharray: "4.17 4.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 25",
    d: "M7.13267 83.7523L5.99023 83.7173",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 27",
    d: "M6.31322 81.5861L5.4939 82.3514",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 29",
    d: "M4.17784 80.5969L4.16064 81.7139",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 31",
    d: "M1.97705 81.3636L2.77266 82.1782",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 33",
    d: "M1 83.4379L2.14184 83.4728",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 35",
    d: "M1.81958 85.6041L2.6395 84.8387",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 37",
    d: "M3.95483 86.5934L3.97203 85.4765",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 39",
    d: "M6.15621 85.8264L5.3606 85.0118",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 41",
    d: "M156.119 67.8279L155.617 68.3716",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 43",
    d: "M153.761 68.3004L154.14 68.6496",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 45",
    d: "M153.379 70.71L153.882 70.1663",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 47",
    d: "M155.736 70.2376L155.358 69.8884",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 49",
    d: "M110.127 3.93275L108.913 3.90015",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 51",
    d: "M106.984 1L106.966 2.03809",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 53",
    d: "M103.604 3.64062L104.819 3.67264",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 55",
    d: "M106.747 6.57337L106.765 5.53528",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 57",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1714 116.018C19.2975 116.279 17.8421 117.563 17.3441 119.086C17.2605 117.671 16.3623 115.893 15.374 115.637C16.5799 115.211 17.886 113.644 18.2334 112.324C18.1705 113.707 19.4268 115.717 20.1714 116.018Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 59",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6379 9.49311C39.9639 9.61228 38.7693 10.4423 38.2665 11.5331C38.3264 10.4725 37.8112 9.07041 37.0974 8.79414C38.0323 8.58071 39.141 7.52661 39.5139 6.5733C39.3473 7.59894 40.1091 9.20439 40.6379 9.49311Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 61",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.982 17.195C129.081 17.1754 128.367 16.4302 128.387 15.5302C128.407 14.6303 129.152 13.9165 130.052 13.9361C130.952 13.9556 131.666 14.7008 131.646 15.6008C131.626 16.5008 130.882 17.2146 129.982 17.195Z",
    fill: "#D1D9E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 63",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.985 123.999C129.202 123.983 128.581 123.333 128.597 122.55C128.614 121.767 129.263 121.145 130.047 121.162C130.831 121.179 131.452 121.828 131.435 122.611C131.418 123.395 130.769 124.016 129.985 123.999Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 65",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1588 38.8262C11.6739 38.8155 11.2891 38.4141 11.2998 37.9286C11.3099 37.4436 11.7118 37.0595 12.1968 37.0695C12.6817 37.0802 13.0665 37.4816 13.0564 37.9665C13.0457 38.4521 12.6438 38.8368 12.1588 38.8262Z",
    stroke: "#D2D8DF",
    strokeWidth: 0.827259,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M70 87.5556V62L71.9167 63.9167L73.8333 62L75.75 63.9167L77.6667 62L79.5833 63.9167L81.5 62L83.4167 63.9167L85.3333 62L87.25 63.9167L89.1667 62L91.0833 63.9167L93 62V87.5556L91.0833 85.6389L89.1667 87.5556L87.25 85.6389L85.3333 87.5556L83.4167 85.6389L81.5 87.5556L79.5833 85.6389L77.6667 87.5556L75.75 85.6389L73.8333 87.5556L71.9167 85.6389L70 87.5556ZM73.8333 81.1667H89.1667V78.6111H73.8333V81.1667ZM73.8333 76.0556H89.1667V73.5H73.8333V76.0556ZM73.8333 70.9444H89.1667V68.3889H73.8333V70.9444Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M87.0529 93.1929C86.0978 92.2704 85.336 91.167 84.8119 89.9469C84.2878 88.7269 84.0119 87.4147 84.0004 86.0869C83.9888 84.7591 84.2419 83.4423 84.7447 82.2133C85.2475 80.9844 85.99 79.8679 86.9289 78.9289C87.8679 77.99 88.9844 77.2475 90.2133 76.7447C91.4423 76.2419 92.7591 75.9888 94.0869 76.0004C95.4147 76.0119 96.7269 76.2878 97.9469 76.8119C99.167 77.336 100.27 78.0978 101.193 79.0529C103.014 80.9389 104.022 83.4649 104 86.0869C103.977 88.7089 102.925 91.217 101.071 93.0711C99.217 94.9251 96.7089 95.9768 94.0869 95.9996C91.4649 96.0224 88.9389 95.0145 87.0529 93.1929ZM93.1229 81.1229V87.1229H95.1229V81.1229H93.1229ZM93.1229 89.1229V91.1229H95.1229V89.1229H93.1229Z",
    fill: "#06C671"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReceipts);
export default __webpack_public_path__ + "static/media/noReceipts.6a8fb3b7759e3429e79ddd5e6a215c3e.svg";
export { ForwardRef as ReactComponent };